<template>
	<div id="" ref="">
		<input type="file" ref="idFile" style="display:none;" accept=".apk,.zip" @change="onFileChange"/>
		<div style="float:left; width:460px; height:40px; line-height:40px; text-indent:10px; margin-top:30px; border-bottom:2px solid #cccccc;" ref="idFName"></div>
		<div class="NButton DIVNoSelect" style="width:110px; padding-left:10px; padding-right:10px; margin-top:36px; margin-left:10px;" @click="onFileClick">选择文件</div>

		<div style="float:left; width:100%; height:12px; margin-top:3px;">
			<div style="float:left; width:580px; height:12px; border-radius:5px; border:1px solid #2a83cf; margin-top:16px; display:block; position:relative;">
				<div style="position:absolute; width:0%; height:10px; line-height:10px; border-radius:5px; background:#b4ea74;" ref="idProgBar"></div>
				<div style="position:absolute; width:100%; height:10px; line-height:10px; color:#2a83cf; text-align:center; font-size:8px; font-style: italic;" ref="idProgCapt"></div>
			</div>
		</div>

		<div style="float:left; margin-top:30px; margin-left:10px; display:flex; align-items:center;">
			<radio ref="idForce1" style="height:30px; margin-right:20px;" v-model="force" :size="18" :root="{obj:this}" :grpName="'GrpForce'" :val="'1'" :capt="'强制'" ></radio>
			<radio ref="idForce0" style="height:30px; margin-right:20px;" v-model="force" :size="18" :root="{obj:this}" :grpName="'GrpForce'" :val="'0'" :capt="'不强制'"></radio>
		</div>

		<div style="float:left; width:100%; height:40px; margin-top:20px; border:0px solid red;">
			<div class="NButton DIVNoSelect" style="padding-left:10px; padding-right:10px; margin-top:16px; margin-left:50px;" @click="onCancelClick">取消</div>
			<div class="NButton DIVNoSelect" style="padding-left:10px; padding-right:10px; margin-top:16px; margin-right:50px; float:right;" @click="onUploadClick">上传</div>
		</div>

	</div>
</template>

<script>
//HFuns_V2.00.05.apk
const APP_FMT = /^.*(_V([1-9])\.([0-9][0-9])\.([0-9][0-9])_R\.(apk|zip))$/;

import radio      from '../cf/cradio'

export default {
	name: 'verNew',
	components:{
		radio
	},
	data () {
		return {
			curVer: null,
			force: 0,
			appVerno: "",
			prog: 0,
			imgW: 0,   //图片的原始宽度
			imgH: 0,   //图片的原始高度
			FName: "", //素材名
		}
	},
	mounted: function(){
		this.curVer = this.$route.query.curVer;
		this.$refs["idForce"+this.force].setChecked( true );
	},
	computed:{

	},
	methods:{
		onFileChange: function(){
			let file=this.$refs["idFile"];
			let filePic = file.files[0];

			this.$refs["idFName"].innerText = filePic.name;
			if( !APP_FMT.test(filePic.name) )
			{
				alert( "错误的文件名格式" );
				return;
			}

			this.appVerno = filePic.name.substring( filePic.name.length-13, filePic.name.length-6 ).replace(/\./g, "");
		},
		onFileClick: function(){
			this.$refs["idFile"].files = null;
			this.$refs["idFile"].click();
		},
		onCancelClick: function(){
			this.$parent.onPopWinClose( );
		},

		/* 上传文件 */
		onUploadClick: function(){
			if( this.$refs["idFile"].files.length==0 ) return;

			this.prog = 0;
			this.$refs["idProgBar"].style["width"] = this.prog+"%";
			this.$refs["idProgCapt"].innerText = this.prog+"%";

			this.doUpload( ServAddr+"/api/app/uploadVersion", this.$refs["idFile"].files[0], true, this.onFileFinish, this.ProgressBar )
		},
		ProgressBar: function( evt ){
			let v=parseInt(evt.loaded * 100 / evt.total);
			this.$refs["idProgBar"].style["width"] = v+"%";
			this.$refs["idProgCapt"].innerText = v+"%";
		},
		onFileFinish: function( res ){
			this.appRoot.app.closeDlgRun();

			if( res.code == 200 )   // 上传成功
			{
				let body={ 	avAppId:       parseInt(this.curVer.avAppId),
							avOs:          this.curVer.avOs,
							avId:          parseInt(this.curVer.avAppId+""+this.appVerno),
							appVerno:      this.appVerno,
							avPublishDate: this.getDTStr( 1, 0, 0, 0 ),
							avPath:        res.body.filePath,
							avForce:       parseInt(this.force) };
				console.log( body );
				this.doTrade( "POST", ServAddr+"/api/app/verAdd", this.onSourceAddOK, true, body, null );
			}
			else
			{
				this.appRoot.app.showDlgTip( 1200, "上传失败", this.CLR.Err );
			}
		},
		onSourceAddOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			this.$parent.onPopWinClose2();
			if( data.code == 200 )
				 this.appRoot.app.showDlgTip( 1200, "添加成功", this.CLR.Suc, this.$parent.onPopWinClose, true );
			else this.appRoot.app.showDlgTip( 1200, "添加失败", this.CLR.Err, this.$parent.onPopWinClose, true );
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// verNew.vue?41b8ec1f